<template>
  <v-card class="pa-0" elevation="0">
    <v-card-text class="px-6 py-6">
      <div class="py-16 text-center" v-if="loading !== ''">
        <br><br><br>
        <v-progress-circular color="primary" indeterminate size="25"></v-progress-circular>
        <div class="mx-auto mt-10 text-h6" style="max-width: 300px">
          {{ loading }}
        </div>
        <br><br><br>
      </div>

      <template v-else>
        <div v-if="view === 'bank-walkthrough'">
          <BankWalkthrough @start="start()"/>
        </div>

        <div v-if="view === 'default-walkthrough'">
          <DefaultWalkthrough @start="start()"/>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import DefaultWalkthrough from "@/components/eligibility/DefaultWalkthrough";
import BankWalkthrough from "@/components/eligibility/BankWalkthrough";
import { jsonToBase64 } from "@/lib/utils";

export default {
  name: "DataWidget",
  components: { DefaultWalkthrough, BankWalkthrough },
  data() {
    return {
      loading: '',
      request: this.$store.state.request,
      merchant: this.$store.state.merchant,
      iframe: null,
      view: '',
    }
  },
  async created() {
    if (this.merchant.partnership === 1) this.view = 'bank-walkthrough';
    if (this.merchant.partnership === 0) this.view = 'default-walkthrough';
  },
  mounted() {
    window.addEventListener('message', this.handleMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleMessage);
    if (this.iframe) this.iframe.remove();
  },
  methods: {
    async handleMessage(e) {
      if (!e.data || !e.data.id) return;
      if (e.data.id === 'success' || e.data.id === 'cclan-success') {
        this.iframe.remove();
        this.loading = '';
        await this.addToCompleted('data');
        await this.saveCreditclanRequestId(e.data.request_id);
        await this.updateWidgetStage(4);
      }
      if (e.data.id === 'cancel' || e.data.id === 'cclan-cancel') {
        this.loading = '';
        this.iframe.remove();
      }
    },
    async start() {
      this.launchDataCollectionWidget();
    },
    launchDataCollectionWidget() {
      this.loading = 'Connecting with banks..';
      const { customer, request } = this.$store.state;
      const data = {
        loan: {
          amount: request.total_credit,
          tenor: request.no_of_months,
        },
        profile: {
          picture: '',
          personal: {
            full_name: customer.personal.full_name,
            email: customer.personal.email,
            phone: customer.personal.phone,
            date_of_birth: customer.personal.date_of_birth,
            gender: customer.personal.gender,
            marital_status: '',
            nationality: '',
            state_of_origin: ''
          },
        },
        extra: {
          merchant_id: this.$store.state.merchant.id
        }
      };
      const forms = ['profile', 'location', 'employment', 'frequently_called_numbers', 'identity', 'bank_statement'];
      const payload = {
        banner: 'https://images.unsplash.com/photo-1605902711834-8b11c3e3ef2f?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80',
        key: 'z2BhpgFNUA99G8hZiFNv77mHDYcTlecgjybqDACv',
        data, forms,
      };
      const token = jsonToBase64(payload);
      const url = `https://cc-datawidget.netlify.app/?token=${ token }`;
      this.launchIframe(url);
      this.loading = '';
    },
    launchIframe(url) {
      const iframe = document.createElement('IFRAME');
      iframe.setAttribute('src', url);
      iframe.setAttribute('allow', 'geolocation');
      const style = {
        'z-index': '999999',
        overflow: 'hidden',
        margin: 0,
        padding: 0,
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100vh',
      };
      Object.assign(iframe.style, style);
      this.iframe = iframe;
      document.body.append(iframe);
    },
    async updateWidgetStage(stage) {
      const res = await this.$http.patch('https://sellbackend.creditclan.com/merchantclan/public/index.php/api/stages', {
        creditclan_request_id: this.$store.state.request.creditclan_request_id, stage
      });
      if (res.data.status) this.$store.commit('request/set', { stage });
    },
    async saveCreditclanRequestId(creditclan_request_id) {
      const request_id = this.$store.state.request.id;
      await this.$http.patch(`https://sellbackend.creditclan.com/merchantclan/public/index.php/api/request/${ request_id }`, { creditclan_request_id })
      this.$store.commit('request/set', { creditclan_request_id });
    },
    async addToCompleted(value) {
      const id = this.request.id;
      const analysis_completed = [...this.request.analysis_completed];
      analysis_completed.push(value);
      await this.$http.patch(`https://sellbackend.creditclan.com/merchantclan/public/index.php/api/stages/${ id }`, {
        analysis_completed, type: 'customer'
      });
      this.$store.commit('request/set', { analysis_completed });
    }
  },
}
</script>
